module.exports = __webpack_public_path__ + "img/note_taker.c473b3f0.svg";